<app-header-component
  (toggle)="toggleDrawer(drawer)"
  [selectedPage]="selected"
  [isLoggedIn]="loggedIn"
></app-header-component>
<kendo-drawer-container>
  <kendo-drawer
    #drawer
    [width]="drawerWidth"
    [items]="items"
    [mode]="mode"
    [mini]="mini"
    [expanded]="expanded"
    [animation]="true"
    [autoCollapse]="autoCollapse"
    (select)="onSelect($event)"
  >
  </kendo-drawer>
  <kendo-drawer-content>
    <router-outlet></router-outlet>
  </kendo-drawer-content>
</kendo-drawer-container>
